// removed by extract-text-webpack-plugin
module.exports = {"app":"localIdentName-main__app___36NQS"};


//////////////////
// WEBPACK FOOTER
// ./css/main.css
// module id = 1429
// module chunks = 0